import {
  CreateUpdatePermission,
  CreateUpdateRole,
  Permission,
  Role,
  RoleFieldAccessResponse,
  ConfigureRoleFieldAccessRequest,
} from "@/types/breeze/RoleAndPermission";
import { BaseService } from "../BaseService";

export class RoleAndPermissionService extends BaseService {
  public async getRoles(): Promise<Role[]> {
    return this.getRequest(`/roles`);
  }

  public async getRole(roleId: number): Promise<Role> {
    return this.getRequest(`/roles/${roleId}`);
  }

  public async createRole(role: CreateUpdateRole): Promise<Role> {
    return this.postRequest(`/roles`, role, "Role created");
  }

  public async updateRole(
    roleId: number,
    role: CreateUpdateRole,
  ): Promise<Role> {
    return this.putRequest(`/roles/${roleId}`, role, "Role updated");
  }

  public async deleteRole(roleId: number): Promise<void> {
    return this.deleteRequest(`/roles/${roleId}`, "Role deleted");
  }

  public async getPermissions(): Promise<Permission[]> {
    return this.getRequest(`/permissions`);
  }

  public async getPermission(permissionId: number): Promise<Permission> {
    return this.getRequest(`/permissions/${permissionId}`);
  }

  public async createPermission(
    permission: CreateUpdatePermission,
  ): Promise<Permission> {
    return this.postRequest(`/permissions`, permission, "Permission created");
  }

  public async updatePermission(
    permissionId: number,
    permission: CreateUpdatePermission,
  ): Promise<Permission> {
    return this.putRequest(
      `/permissions/${permissionId}`,
      permission,
      "Permission updated",
    );
  }

  public async deletePermission(permissionId: number): Promise<void> {
    return this.deleteRequest(
      `/permissions/${permissionId}`,
      "Permission deleted",
    );
  }

  // Role Field Access methods
  public async getRoleFieldAccessByEntity(
    roleId: number,
    entityId: number,
  ): Promise<RoleFieldAccessResponse> {
    return this.getRequest(
      `/roles/${roleId}/field-access/entities/${entityId}`,
    );
  }

  public async configureRoleFieldAccess(
    roleId: number,
    request: ConfigureRoleFieldAccessRequest,
  ): Promise<void> {
    return this.postRequest(
      `/roles/${roleId}/field-access`,
      request,
      "Field access configured",
    );
  }

  public async deleteRoleFieldAccessForEntity(
    roleId: number,
    entityId: number,
  ): Promise<void> {
    return this.deleteRequest(
      `/roles/${roleId}/field-access/entities/${entityId}`,
      "Field access reset",
    );
  }
}

export const roleAndPermissionService = new RoleAndPermissionService();
